<div class="row ss-top-menu">
    <div class="col-6">
        <!-- <span class="ss-text-light" style="vertical-align: -webkit-baseline-middle;">
      Project
      <i class="rightArrow fa fa-angle-right"></i> 
    </span> -->
        <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">Calender</span>
    </div>
    <div class="col-6">
        <div class="row">
            <div class="col-md-12">
                <button type="button" class="btn btn-pink pull-right" data-toggle="modal" (click)="setCurrentTimestamp()" data-target="#eventModal" *ngIf="role != 'sitesupervisor'">
          CREATE EVENT
        </button>
            </div>
        </div>
    </div>
</div>
<div class="col-12" *ngIf="erroralert">
    <div class="alert-box grid-100" *ngIf="errorMessage">
        <div class="alert alert-danger mt-3 text-center">
            <a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a> {{errorMessage}}
        </div>
    </div>
</div>
<div class="col-12" *ngIf="successalert">
    <div class="alert-box grid-100" *ngIf="successMessage">
        <div class="alert alert-success mt-3 text-center">
            <a class="close link" data-dismiss="alert" (click)="successalert=false">×</a> {{successMessage}}
        </div>
    </div>
</div>

<div class="row mt-5" >
    <div class="col-sm-12 text-right mb-4" *ngIf="designer_list">
        <button class="rk-interalBtnColor mr-2 addCursor" (click)="actionable_Filter('')">All</button>
        <button class="rk-interalBtnColor mr-2 addCursor" (click)="actionable_Filter('cm')">CM Actionable</button>
        <button class="rk-interalBtnColor mr-2 addCursor" (click)="actionable_Filter('designer')">Designer Actionable</button>
    </div>
    
    <div class="col-sm-3">
      <span>Filter by Event Type</span>
      <select class="form-control" (change)="filterEvent($event)">
    <option value="all">All</option>
    <option value="0-50">0-50 % NOC Events</option>
    <option value="50-100">50-100 % NOC Events</option>
    <option value="manual">Manual Events</option>
    <option value="others">Others Events</option>
  </select>
  </div>
</div>

<!--For GM,CM and Designer Filter-->
<div class="row">
  <div class="col-md-3 filter2 ml-3" [ngClass]="{'d-none':role=='community_manager'|| role =='designer'|| role =='city_gm' || role=='design_manager'}">
      <span class="text-danger pull-right text-bold cursor-pointer mt-1" (click)="ClearGmFilter()" style="font-size: 12px">Clear</span>
        <span class="fltype">Filter by GM</span>
      <div class="floptions">
          <angular2-multiselect [data]="gm_dropdownList" [(ngModel)]="selectedGmItems"
          [settings]="gm_dropdownSettings"
          (ngModelChange)="onItemSelect($event,'gm',3)"
          (onDeSelect)="OnItemDeSelect($event,'gm',3)"
          (onSelectAll)="onSelectAll($event)"
          (onDeSelectAll)="onDeSelectAll($event)"></angular2-multiselect>
        </div>
    </div>
  <div class="col-md-3 filter2" [ngClass]="{'d-none':role=='community_manager'|| role =='designer'}" [ngStyle]="{'margin-left':(role =='city_gm' || role=='design_manager') ? '2%':'0%'}">
      <span class="text-danger pull-right text-bold cursor-pointer mt-1" (click)="ClearCmFilter()" style="font-size: 12px">Clear</span>
        <span class="fltype">Filter by CM</span>
      <div class="floptions">
          <angular2-multiselect [data]="cm_dropdownList" [(ngModel)]="selectedCmItems"
          [settings]="cm_dropdownSettings"
          (ngModelChange)="onItemSelect($event,'cm',1)"
          (onDeSelect)="OnItemDeSelect($event,'cm',1)"
          (onSelectAll)="onSelectAll($event)"
          (onDeSelectAll)="onDeSelectAll($event)"></angular2-multiselect>
        </div>

    </div>
    <div class="col-md-3 filter2" [ngClass]="{'d-none': role =='designer'}">
      <span class="text-danger pull-right text-bold cursor-pointer mt-1" (click)="CleardesignerFilter()" style="font-size: 12px">Clear</span>
        <span class="fltype">Filter by DESIGNER</span>
        <div class="floptions">
          <angular2-multiselect [data]="designer_dropdownList" [(ngModel)]="selectedDesignerItems"
          [settings]="designer_dropdownSettings"
          (ngModelChange)="onItemSelect($event,'designer',2)"
          (onDeSelect)="OnItemDeSelect($event,'designer',2)"
          (onSelectAll)="onSelectAll($event)"
          (onDeSelectAll)="onDeSelectAll($event)"></angular2-multiselect>
        </div>
    </div>
</div>
<!---->

<div class="row my-4">
    <div class="col-md-12">
        <div class="calendar-container calendarMB">
            <div id='calendar' #calendar></div>
        </div>
    </div>
</div>

<div class="modal fade" id="eventModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" *ngIf="role != 'sitesupervisor'">
    <div class="modal-dialog modal-lg" role="document" style="margin-top: 5rem;">
        <div class="modal-content">
            <div class="modal-header" style="border-bottom: 1px solid #e4e4e4;">
                <h6 class="modal-title" id="exampleModalLabel">Schedule a meeting </h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <form [formGroup]="meetingform" (ngSubmit)="createEvent()">
                            <div class="form-group row">
                                <label class="col-3 col-lg-2 col-form-label">Project *</label>
                                <div class="col-9 col-lg-10">
                                  <select class="form-control" formControlName="project" required="true" (change)="onProjectChange($event.target.value)">
                                    <option value=null>Choose your project</option>
                                    <option *ngFor="let lead of leads" [value]="lead.ownerable_id">{{lead.ownerable_id}} - {{lead.name}} - {{lead.project_name}}</option>
                                  </select>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-3 col-lg-2 col-form-label">Agenda *</label>
                                <div class="col-9 col-lg-10">
                                    <select class="form-control" formControlName="agenda" (change)="firstMeeting()"  required="true" id="agendaType">
                                      <option value=null>Choose an agenda</option>
                                      <option *ngFor="let lang of list_agenda" [value]="lang">{{lang | replaceChar}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-3 col-lg-2 col-form-label">Type *</label>
                                <div class="col-9 col-lg-10">
                                    <select disabled class="form-control" formControlName="contact_type" id="typeSel" type='select' required="true">
                                      <option value=null disabled>Choose type of interaction</option>

                                     <ng-container *ngIf="loc == 'follow_up_call'">
                                        <option value="phone_call"id="phone_call">Phone Call</option>
                                        <option value="video_call">Video Call</option>
                                        <option value="experience_center">EC Visit</option>
                                        <option value="site_visit">Site Visit</option>
                                      </ng-container>

                                      <ng-container *ngIf="loc == 'first_meeting'">
                                        <option value="experience_center">EC Visit</option>
                                        <option value="site_visit">Site Visit</option>
                                        <option value="phone_call"id="phone_call">Phone Call</option>
                                        <option value="video_call">Video Call</option>
                                      </ng-container>

                                      <ng-container *ngIf="loc == 'follow_up_meeting'">
                                        <option value="experience_center">EC Visit</option>
                                        <option value="site_visit">Site Visit</option>
                                        <option value="phone_call"id="phone_call">Phone Call</option>
                                        <option value="video_call">Video Call</option>            
                                      </ng-container>

                                      <ng-container *ngIf="loc == 'design_and_boq_presentation'">
                                        <option value="experience_center">EC Visit</option>
                                        <option value="site_visit">Site Visit</option>
                                        <option value="video_call">Video Call</option>
                                        <option value="phone_call"id="phone_call">Phone Call</option>
                                      </ng-container>

                                      <ng-container *ngIf="loc == 'material_finalisation_meeting'">
                                        <option value="experience_center">EC Visit</option>
                                        <option value="site_visit">Site Visit</option>
                                        <option value="video_call">Video Call</option>
                                        <option value="phone_call"id="phone_call">Phone Call</option>
                                      </ng-container>

                                      <ng-container *ngIf="loc == 'closure'">
                                        <option value="experience_center">EC Visit</option>
                                        <option value="site_visit">Site Visit</option>
                                        <option value="video_call">Video Call</option>
                                        <option value="phone_call"id="phone_call">Phone Call</option>
                                      </ng-container>

                                      <!-- <option *ngFor="let lang of langs" [value]="lang">{{lang}}</option> -->
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-3 col-lg-2 col-form-label">Description</label>
                                <div class="col-9 col-lg-10">
                                    <input type="text" class="form-control" formControlName="description" placeholder="What is this meeting about?">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-2 col-form-label">Date *</label>
                                <div class="col-10">
                                    <input type="datetime-local" formControlName="scheduled_at" class="form-control" required="true" min="{{todayDate}}">
                                </div>
                            </div>

                            <div class="form-group row ">
                                <label class="col-3 col-lg-2 col-form-label">Location</label>
                                <div class="col-9 col-lg-10">
                                    <input type="text" class="form-control" formControlName="location" placeholder="Enter the location">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-3 col-lg-2 col-form-label">Notify To *</label>
                                <div class="col-9 col-lg-10">
                                    <div class="form-check pull-left" *ngFor="let user of projectUsers" style="margin-left: 1.3rem;margin-right: 2rem;">
                                        <input type="checkbox" class="form-check-input" name="users" value="{{user.email}}" id="{{user.email}}" (change)="onMeetingUserChange($event,'meeting')">
                                        
                                        <label class="form-check-label" for="{{user.email}}" style="padding-left: 0.25rem;">{{user.name}}</label>
                                    </div>
                                </div>
                                <div class="col-3 col-lg-2"></div>
                                <div class="col-9 col-lg-10 pull-right">
                                    <input type="text" class="form-control meeting-control" formControlName="email" placeholder="Add semi-colon for multiple emails">
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-12 text-right">
                                    <button type="submit" class="btn btn-pink" [disabled]="!meetingform.valid">Send invites</button>
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>

                        </form>
                        <!-- <pre>{{meetingform.value | json}}</pre> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="viewEventModal" tabindex="-1" role="dialog" aria-labelledby="viewEventModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document" style="margin-top: 5rem;">
        <div class="modal-content" style="overflow: auto">
            <div class="modal-header" style="border-bottom: 1px solid #e4e4e4;">
                <h6 class="modal-title" id="viewEventModalLabel"> details </h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <div class="phone pull-right">
                <a  data-toggle="modal" data-target="#alternateNumberModal"><i class="fa fa-phone cursor-pointer" (click)="getCustomerDetails()" style="    font-size: 1.5rem; color: #8F0020;"></i></a>&nbsp;&nbsp;
              <!-- <i class="fa fa-phone cursor-pointer" (click)="callFromCalenderToLead()" style="    font-size: 1.5rem; color: #8F0020;"></i> -->
            </div>
          </div>  
          <div class="col-md-12">
            <div class="form-group row" id="lead_id">
              <label class="col-3 col-form-label">Lead ID</label>
              <div class="col-9 modal-lead_id">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-3 col-form-label">Lead</label>
              <div class="col-9 modal-lead">
              </div>
            </div>

            <div class="form-group row" id="event_boq_num">
              <label class="col-3 col-form-label">BOQ Number</label>
              <div class="col-9 modal-boq-num">
              </div>
            </div>

            <div class="form-group row" id="event_project">
              <label class="col-3 col-form-label">Project</label>
              <div class="col-9 modal-project">
              </div>
            </div>

            <div class="form-group row">
              <label class="col-3 col-form-label">Agenda</label>
              <div class="col-9 modal-agenda">

              </div>
            </div>

            <div class="form-group row" id="furemark-hide">
              <label class="col-3 col-form-label">Follow up Remark</label>
              <div class="col-9 modal-furemark">

              </div>
            </div>

            <div class="form-group row" id="event_type">
              <label class="col-3 col-form-label">Type</label>
              <div class="col-9 modal-type">

              </div>
            </div>

            <div class="form-group row des-chng" id="event_desc">
              <label class="col-3 col-form-label">Description</label>
              <div class="col-9 modal-description">

              </div>
            </div>

            <div class="form-group row">
              <label class="col-3 col-form-label">Date</label>
              <div class="col-9 modal-date">
                
              </div>
            </div>

            <div class="form-group row location-chng" id="event_location">
              <label class="col-3 col-form-label">Location</label>
              <div class="col-9 modal-location">
                
              </div>
            </div>
            <div class="form-group row" id="designer-hide">
              <label class="col-3 col-form-label">Designer</label>
              <div class="col-9 modal-designer">

              </div>
            </div>
            <div class="form-group row" id="event_member">
              <label class="col-3 col-form-label">Members</label>
              <div class="col-9 modal-members">

              </div>
            </div>
            <div class="form-group row">
              <label class="col-3 col-form-label">Status</label>
              <div class="col-9 modal-status">

              </div>
            </div>
            <div class="form-group row" id="status-change" *ngIf="role == 'designer'">
                <label class="col-3 col-form-label">Change Status</label>
                <div class="col-9">
                 <select (change) = "onStatusChange($event.target.value)">
                    <option>Change Status</option>
                    <option value="not_contactable" >Not Contactable</option>
                    <option value="follow_up" >Follow Up</option>
                    <option value="wip" >WIP</option>
                  </select>
                </div>
            </div>

            

            <div class="form-group row" id="remark-hide">
              <label class="col-3 col-form-label">Remarks</label>
              <div class="col-9 modal-remark">

              </div>

            </div>
            <!-- <div class="form-group row" id="supervisor-hide">
              <label class="col-3 col-form-label">Assigned Site Supervisor</label>
              <div class="col-9 modal-remark">

              </div>

            </div> -->
            <div class="modal-footer" style="justify-content: flex-start;">
              <button type="button" id="btn-hide" class="btn btn-pink" (click)="updateStatus('reschedule')">Reschedule</button>
              <button type="button" id="noc-btn-hide" class="btn btn-pink" (click)="updateStatus('noc_reschedule')">Reschedule Expected Date</button>
              <button type="button" id="btn-hides" class="btn btn-pink" (click)="updateStatus('done')">Mark done</button>
              <button type="button" id="btn-cancel-hide" class="btn btn-pink" (click)="updateStatus('cancelled')">Meeting Cancel</button>
              <button type="button" id="mom-add" class="btn btn-pink" data-toggle="modal" data-target="#addmom" (click) = showcreateMOM()>Add MOM</button>
              <a class="btn btn-pink" id="momview" href="#" data-toggle="modal" data-target="#view-mom" (click) = "showMOM()">View MOM</a>
            </div>
        </div>
    </div>
</div>


<!--MOM Modal-->
<div class="modal fade" id="addmom" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" *ngIf="role != 'sitesupervisor'">
  <div class="modal-dialog modal-lg" role="document" style="margin-top: 5rem;">
    <div class="modal-content">
      <div class="modal-header" style="border-bottom: 1px solid #e4e4e4;">
        <h6 class="modal-title" id="exampleModalLabel">Add MOM </h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <form [formGroup]="mom" (ngSubmit)="createMOM()">
          <textarea formControlName = "mom_description" rows="4" cols="50" name="comment" placeholder="Enter Description..">
          </textarea>
          <div class="mt-3" *ngFor= "let user of calEvent">
            <input type="checkbox" [(ngModel)]="Emails" value="{{user.email}}" (change)="OnEmailSelect($event)">
            <label class="form-check-label" for="{{user.email}}" style="padding-left: 0.25rem;">{{user.name}} ({{user.email}})</label>
          </div>
          
          <button class="btn btn-pink mt-3" type="submit" (click)="createMOM()" [disabled]="!mom.valid">Submit</button>
        </form>
      </div>
    </div>
  </div>
</div>

<!--View mom modal-->
<div class="modal fade mt-5" id="view-mom" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg mt-4" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">View MOM</h5>
        <button type="button" class="close" (click) = "closeViewMoM()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body" *ngIf = "view_mom" style="overflow-y: auto;">
        <p>{{view_mom.mom_description}}</p>
      </div>

      <div class="modal-footer">
        <button class="btn btn-pink" (click) = "closeViewMoM()">Close</button>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="updateEventModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" *ngIf="role != 'sitesupervisor'">
    <div class="modal-dialog modal-lg" role="document" style="margin-top: 5rem;">
        <div class="modal-content">
            <div class="modal-header" style="border-bottom: 1px solid #e4e4e4;">
                <h6 class="modal-title" id="exampleModalLabel">Schedule a meeting </h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <form [formGroup]="updatemeetingform" (ngSubmit)="updateEvent()">
                            <div class="form-group row">
                                <label class="col-3 col-lg-2 col-form-label">Project *</label>
                                <div class="col-9 col-lg-10">
                                    <select class="form-control" formControlName="project" required="true" (change)="onProjectChange($event.target.value)" disabled="true" >
                                      <option value=null>Choose your project</option>
                                      <option *ngFor="let lead of leads" [value]="lead.ownerable_id">{{lead.ownerable_id}} - {{lead.name}} - {{lead.project_name}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-3 col-lg-2 col-form-label">Agenda *</label>
                                <div class="col-9 col-lg-10">
                                    <select class="form-control" formControlName="agenda" disabled="true">
                                      <option value=null>Choose an agenda</option>
                                      <option value="first_meeting">First Meeting</option>
                                      <!-- <option value="briefing_sales_pitch">Briefing/Sales Pitch</option> -->
                                      <option value="follow_up_meeting">Follow Up Meeting</option>
                                      <option value="follow_up_call">Follow Up Call</option>
                                      <option value="design_and_boq_presentation">Design and BOQ Presentation</option>
                                      <!-- <option *ngFor="let lang of langs" [value]="lang">{{lang}}</option> -->
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row">
                              <label class="col-2 col-form-label">Type *</label>
                              <div class="col-10">
                                <select disabled class="form-control" formControlName="contact_type" required="true" id="typeSel" type='select'>
                                  <option value=null disabled>Choose type of interaction</option>

                                  <ng-container *ngIf="loc == 'follow_up_call'">
                                    <option value="phone_call"id="phone_call">Phone Call</option>
                                    <option value="video_call">Video Call</option>
                                    <option value="experience_center">EC Visit</option>
                                    <option value="site_visit">Site Visit</option>
                                  </ng-container>

                                  <ng-container *ngIf="loc == 'first_meeting'">
                                    <option value="experience_center">EC Visit</option>
                                    <option value="site_visit">Site Visit</option>
                                    <option value="phone_call"id="phone_call">Phone Call</option>
                                    <option value="video_call">Video Call</option>
                                  </ng-container>

                                  <ng-container *ngIf="loc == 'follow_up_meeting'">
                                    <option value="experience_center">EC Visit</option>
                                    <option value="site_visit">Site Visit</option>
                                    <option value="phone_call"id="phone_call">Phone Call</option>
                                    <option value="video_call">Video Call</option>            
                                  </ng-container>

                                  <ng-container *ngIf="loc == 'design_and_boq_presentation'">
                                    <option value="experience_center">EC Visit</option>
                                    <option value="site_visit">Site Visit</option>
                                    <option value="experience_center">EC Visit</option>
                                    <option value="video_call">Video Call</option>
                                    <option value="phone_call"id="phone_call">Phone Call</option>
                                  </ng-container>
                                  
                                  <!-- <option *ngFor="let lang of langs" [value]="lang">{{lang}}</option> -->
                                </select>
                              </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-3 col-lg-2 col-form-label">Description</label>
                                <div class="col-9 col-lg-10">
                                    <input type="text" class="form-control" formControlName="description" placeholder="What is this meeting about?">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-2 col-form-label">Date *</label>
                                <div class="col-10">
                                    <input type="datetime-local" formControlName="scheduled_at" class="form-control" min="{{todayDate}}">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-3 col-lg-2 col-form-label">Location</label>
                                <div class="col-9 col-lg-10">
                                    <input type="text" class="form-control" formControlName="location" placeholder="Enter the location">
                                </div>
                            </div>
                            
                            <div class="form-group row">
                                <label class="col-3 col-lg-2 col-form-label">Remarks *</label>
                                <div class="col-9 col-lg-10">
                                    <input type="text" class="form-control" formControlName="remark" placeholder="Reason For Reschedule">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-3 col-lg-2 col-form-label">Notify To *</label>
                                <div class="col-9 col-lg-10">
                                    <div class="form-check pull-left" *ngFor="let user of projectUsers" style="margin-left: 1.3rem;margin-right: 2rem;">
                                       <!-- <pre>{{ projectUsers.value | json  }}</pre> -->
                                        <input type="checkbox" class="form-check-input" name="users" value="{{user.email}}" id="update-{{user.email}}" (change)="onMeetingUserChange($event,'update')">
                                        <label class="form-check-label" for="update-{{user.email}}" style="padding-left: 0.25rem;">{{user.name}}</label>
                                    </div>
                                </div>
                                <div class="col-3 col-lg-2"></div>
                                <div class="col-9 col-lg-10 pull-right">
                                    <input type="text" class="form-control meeting-control" formControlName="email" placeholder="Add semi-colon for multiple emails">
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-12 text-right">
                                    <button type="submit" class="btn btn-pink" [disabled]="!updatemeetingform.valid">Send invites</button>
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>

                        </form>
                        <!-- <pre>{{updatemeetingform.value | json}}</pre> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--For NOC Change Date Modal-->
<div id="nocchangeModal" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
  <!-- <div class="vertical-alignment-helper"> -->
  <div class="modal-dialog modal-dialog-centered" style="max-width: 100%;">
    <div class="modal-content modal-change">
      <div class="modal-header" style="background-color: azure;">
        <h4 class="modal-title">{{this.title_details}} Date Details</h4>
        <div class="iconbox">
          <button type="button" class="close close-icon" (click)="closenocModal()">&times;</button>
        </div>
      </div>
      <div class="modal-body modal-body-change p-4">
        <div class="row justify-content-center">
          <div class="col-md-10">
            <div class="row">   
              <div class="col-md-6">Current Expected Date:</div>
              <div class="col-md-6 detailscolor">{{this.noc_date | date:'dd/MM/yyyy - h:mm a'}}</div>
              </div>
          <form [formGroup]="createClassificationForm" (ngSubmit)="dateDetails(createClassificationForm.value);">    
         <div class="row justify-content-center">   
          <label class="col-md-6 col-form-label">Choose New Date:</label>
          <div class="col-md-6">
          <input type="datetime-local" class="form-control" required="true" formControlName="date_detail">
           </div>
         </div>
         <div class="row justify-content-center mt-2">   
          <label class="col-md-6 col-form-label">Select Reason:<span class="astric">*</span></label>
          <div class="col-md-6">
            <select class="form-select" style="width: 100%;
            height: 42px;
            margin-bottom: 11px;" formControlName="select_value" (change)="reasonDropDownChanged($event.target.value)">
              <!-- <option value="" selected>Select Reason</option> -->
              <option value="{{reason}}" *ngFor="let reason of reason_list">{{reason}}</option>
            </select>
           </div>
         </div>
         <div class="row justify-content-center">   
          <label class="col-md-6 col-form-label">Notes:<span class="astric">*</span></label>
          <div class="col-md-6">
            <input type="text" class="form-control" required="true" formControlName="note_detail">
           </div>
         </div>
        <div class="row mt-3" style="text-align: end;">
         <div class="col-md-12">
           <button class="save_changes" type="submit" [disabled]="!createClassificationForm.valid">Save Changes</button>
           </div> 
      </div>
      </form>
    </div>
  </div>
</div>
</div>
</div>
</div>
<!-- For REMARK MODAL -->
<div class="modal fade" id="markModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" *ngIf="role != 'sitesupervisor'">
    <div class="modal-dialog modal-lg" role="document" style="margin-top: 5rem;">
        <div class="modal-content">
            <div class="modal-header" style="border-bottom: 1px solid #e4e4e4;">
                <h6 class="modal-title" id="exampleModalLabel">Give a Remark </h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <form [formGroup]="markDoneform" (ngSubmit)="remarkEvent()">

                            <div class="form-group row">
                                <label class="col-2 col-form-label">Remarks:</label>
                                <div class="col-10">
                                    <input type="text" class="form-control" formControlName="remark" placeholder="Enter Your Remarks..">
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-12">
                                    <button type="submit" class="btn btn-pink" [disabled]="!markDoneform.valid">Submit</button>
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Status modal -->
<div class="modal fade" id="statusModal" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg mobModal" role="document" style="width: 55rem;margin-top: 55px;">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Follow-up Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <img class="close" data-dismiss="modal" src="https://www.homepolish.com/assets/close-ee1bfd7a4473933b6dd934b2c284dc856361b63581c8f43b8cdc1abe07c91765.svg">
    </button>
      </div>
      <div class="modal-body">

        <div class="form-group row">
          <label for="example-text-input" class="col-2 col-form-label">Callback Date</label>
          <div class="col-10">
            <input type="datetime-local" name="followup-details" id="followup-details" class="form-control" (change) = "disableDate()">
          </div>
        </div>
        <div class="form-group row">
          <label for="example-text-input" class="col-2 col-form-label">Remarks </label>
          <div class="col-10">
            <textarea rows="1" name="followup_remarks" id="followup_remarks" class="form-control"></textarea>
            <!-- <input type="da" name="followup-details" id="followup-details" class="form-control"> -->
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <input type="button" id="followup-button" value="Update" class="btn btn-pink" (click) = "onCallbackChange('follow_up')" >
      </div>
    </div>
  </div>
</div>
<!-- Status modal end -->

<div class="modal fade" id="loststatusModal" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg mobModal" role="document" style="width: 55rem;">
    <form [formGroup]="statusChangeForm">
      <div class="modal-content">
        <div class="modal-header">
          <h5>Lost Details</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img class="close" data-dismiss="modal" src="https://www.homepolish.com/assets/close-ee1bfd7a4473933b6dd934b2c284dc856361b63581c8f43b8cdc1abe07c91765.svg">
          </button>
        </div>
        <div class="modal-body">

          <div class="form-group row">
            <label for="example-text-input" class="col-3 col-form-label">Reason for Lost <span class="text-danger">*</span></label>
            <div class="col-9">
              <select class="form-control" id="lost_reason" formControlName="reson_for_lost" (change)="reasonForLostDropdownChange($event.target.value)">
                <option value="" disabled>Select Reason</option>
                <option value="not_in_scope">Not in Scope</option>
                <option value="low_budget">Low Budget</option>
                <option value="out_of_area">Out of Area</option>
                <option value="not_interested">Not Interested</option>
                <option value="already_done_with_other_vendor">Already done with Other Vendor</option>
                <option value="others">Others </option>
              </select>
            </div>
          </div>
          <div class="form-group row" id="lostRemarkRow">
            <label for="example-text-input" class="col-3 col-form-label">Remarks <span class="text-danger">*</span> </label>
            <div class="col-9">
              <textarea rows="1" name="lost_remarks" id="lost_remarks" class="form-control" formControlName="lost_remarks"></textarea>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <input type="button" id="lost-button" value="Update" class="btn btn-pink addCursor" (click) = "onCallbackChange('lost')" [disabled]="!statusChangeForm.valid">
        </div>
      </div>
    </form>
  </div>
</div>

<!-- Modal -->
<div class="modal fade mt-5" id="alternateNumberModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg mt-4" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">Select Contact</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="bg-light col-12 font-weight-bold pr-0">
                    <label for="example-text-input" class="col-4">Name </label>
                    <label for="example-text-input" class="col-4">Relation </label>
                    <!-- <label for="example-text-input" class="col-3">Contact </label> -->
                </div>
              <div class="form-group" *ngFor="let user of customerDetails">
                
                <div class="col-12">
                    <label for="example-text-input" class="col-4">{{user.name}} </label>
                    <label for="example-text-input" class="col-4">{{user.relation}} </label>
                    <!-- <label for="example-text-input" class="col-3">{{user.contact}} </label> -->
                    <label><i class="fa fa-phone cursor-pointer" (click)="callFromCalenderToLead(user.contact)" style="    font-size: 1.5rem; color: #8F0020;"></i></label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>





// WEBPACK FOOTER //
// ./src/app/platform/calender/viewcalender/viewcalender.component.html